export const style = {
  '& .label': {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '1rem',
    lineHeight: '24px',
    marginTop: '3rem'
  },
  '& .logo-icon': {
    border: 1,
    borderColor: 'lightGrey',
    borderRadius: '50%',
    width: '6rem',
    height: '6rem',
    marginTop: '1rem',
    backgroundImage: 'url(pt.png)',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    display: 'flex',
    alignItems: 'end',
    justifyContent: 'end'
  }
};
